module.exports = __webpack_public_path__ + "img/mikroTik.1f469034.svg";